import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ComparisonTablePanel from '../reusable/ComparisonTablePanel';

/**
 * RPPComparisonTable.
 * Comparison table.
 *
 * @author  Manny
 * @param   {Array}      props.addons           List of addons for the product.
 * @param   {Boolean}    props.buyNow           Check if method is buyNow.
 * @param   {Object}     props.features         List of the product's features.
 * @param   {String}     props.industryKey      Name of the industry.
 * @param   {Object}     props.industryPackage  List of packages for the industry.
 * @param   {Boolean}    props.isMobile         Determines if tables are for mobile format.
 * @param   {String}     props.packageKey       Name of the package.
 * @param   {Array}      props.usersGeo         List of information on product's users and geography.
 * @returns {JSX.Element} The component markup.
 */

const RPPComparisonTable = ({
  addons,
  buyNow,
  features,
  industryKey,
  industryPackage,
  isMobile = false,
  packageKey,
  usersGeo
}) => {
  const [openPanels, setOpenPanels] = useState([true, true, false, false, false, false]);
  const { data, mobility, modules, reports } = features || {};

  const togglePanel = (index) => {
    let newOpen = [...openPanels];
    newOpen[index] = !newOpen[index];
    setOpenPanels(newOpen);
  };

  const panelContent = [
    {
      data: usersGeo,
      dataType: 'users_geo',
      iconType: 'usersIcon',
      tableType: 'data',
      title: 'Users & Geography '
    },
    {
      data: data,
      dataType: 'data',
      iconType: 'propertyDataIcon',
      tableType: 'icon',
      title: 'Property Data '
    },
    {
      data: mobility,
      dataType: 'mobility',
      iconType: 'mobilityIcon',
      tableType: 'icon',
      title: 'Mobility '
    },
    {
      data: reports,
      dataType: 'reports',
      iconType: 'reportsIcon',
      tableType: 'icon',
      title: 'Reports '
    },
    {
      data: modules,
      dataType: 'modules',
      iconType: 'modulesIcon',
      tableType: 'icon',
      title: 'Modules '
    },
    {
      data: addons,
      dataType: 'addons',
      iconType: 'addonsIcon',
      tableType: 'icon',
      title: 'Add-Ons '
    }
  ];

  return (
    <div className={isMobile ? 'margin-top-neg-5' : ''}>
      {panelContent.map((content, index) => (
        <ComparisonTablePanel
          buyNow={buyNow}
          data={content.data}
          dataType={content.dataType}
          defaultExpanded={index < 2 ? true : false}
          iconType={content.iconType}
          index={index}
          industryKey={industryKey}
          industryPackage={industryPackage}
          isOpen={openPanels[index]}
          isMobile={isMobile}
          key={`panel_key_${index}`}
          onClick={togglePanel}
          packageKey={packageKey}
          tableType={content.tableType}
          title={content.title}
        />
      ))}
    </div>
  );
};

RPPComparisonTable.propTypes = {
  addons: PropTypes.array,
  buyNow: PropTypes.bool,
  features: PropTypes.object.isRequired,
  industryKey: PropTypes.string,
  industryPackage: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  packageKey: PropTypes.string,
  usersGeo: PropTypes.array.isRequired
};

export default RPPComparisonTable;
